import React from 'react';

import StudentSearch from './StudentSearch';
import StudentInfo from './StudentInfo';

import { CustomScrollbarContainer } from '../../../styles/tabContainers';

/**
 * Główny komponent zakładki Studenci, posiada podział na wyszukiwarkę oraz informację zwrócone w wyniku wyszukiwania z API.
 *
 */
const StudentFinder = (): JSX.Element => {
  return (
    <CustomScrollbarContainer>
      <StudentSearch />
      <StudentInfo />
    </CustomScrollbarContainer>
  );
};

export default StudentFinder;
